const search = () => {
  const links = document.querySelectorAll('.js-search-link');
  const containers = document.querySelectorAll('.js-search-container');

  if (links && containers) {
    containers.forEach(container => {
      let activeLink = null;
      const input = container.querySelector('.js-search-input');
      const form = container.querySelector('.js-search-form');

      links.forEach(link => {
        link.addEventListener('click', event => {
          event.preventDefault();
          container.classList.remove('u-hidden');
          form.classList.add('is-active');
          activeLink = link;
          input.focus();
          if (!link.classList.contains('js-not-hide')) {
            link.classList.add('u-hidden');
          }

          const button = document.querySelector('.js-hamburger');
          const buttonTarget = document.querySelector('.js-hamburger-target');
          button.classList.remove('is-active');
          buttonTarget.classList.remove('is-active');
        });
      });

      input.addEventListener('focusout', () => {
        setTimeout(() => {
          form.classList.remove('is-active');
          container.classList.add('u-hidden');
          activeLink.classList.remove('u-hidden');
        }, 300);
      });

      form.addEventListener('submit', event => {
        event.preventDefault();
        if (document.documentElement.lang === 'pl') {
          window.location = `/?s=${input.value}`;
        } else {
          window.location = `/en/?s=${input.value}`;
        }
      });
    });
  }
  const updateURLParameter = (url, param, paramVal) => {
    let newAdditionalURL = '';
    let tempArray = url.split('?');
    const baseURL = tempArray[0];
    const additionalURL = tempArray[1];
    let temp = '';
    if (additionalURL) {
      tempArray = additionalURL.split('&');
      for (let i = 0; i < tempArray.length; i += 1) {
        if (tempArray[i].split('=')[0] !== param) {
          newAdditionalURL += temp + tempArray[i];
          temp = '&';
        }
      }
    }

    const rowsTxt = `${temp}${param}=${paramVal}`;
    return `${baseURL}?${newAdditionalURL}${rowsTxt}`;
  };
  const radio = document.querySelectorAll('.js-search-list-radio');
  radio.forEach(element => {
    element.addEventListener('change', e => {
      window.location.href = updateURLParameter(
        window.location.href,
        'search_cat',
        e.target.value,
      );
    });
  });
};

export default search;



// WEBPACK FOOTER //
// ./wp/wp-content/themes/vistula-chisel/src/scripts/modules/search.js